export function checkNewUser(name,whatsapp,email,password){
 if (name.length > 3 && whatsapp.length > 9 && password.length > 5 && email.length > 6)
    return true
 else {
     return false
 }   
}